// extracted by css-extract-rspack-plugin
export default {"StrengthIndicator":"QuestionActions-module__StrengthIndicator___AEOiq"};